import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

/**
 * Single-input date range picker using Flatpickr mode: "range".
 * Updates two hidden fields (start_date, end_date) for form submission.
 */
export default class extends Controller {
  static targets = ['input', 'startDateInput', 'endDateInput']
  static values = {
    defaultStartDate: String,
    defaultEndDate: String,
    inline: Boolean,
  }

  connect() {
    const defaultOptions = {
      mode: 'range',
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'M j, Y',
      allowInput: false,
      disableMobile: true,
      inline: this.inlineValue,
    }

    if (this.hasDefaultStartDateValue && this.hasDefaultEndDateValue) {
      defaultOptions.defaultDate = [this.defaultStartDateValue, this.defaultEndDateValue]
    }

    const input = this.hasInputTarget ? this.inputTarget : this.element
    this.flatpickr = flatpickr(input, {
      ...defaultOptions,
      onChange: (selectedDates) => {
        if (selectedDates.length >= 1 && this.hasStartDateInputTarget) {
          this.startDateInputTarget.value = this.formatDate(selectedDates[0])
        }
        if (selectedDates.length >= 2 && this.hasEndDateInputTarget) {
          this.endDateInputTarget.value = this.formatDate(selectedDates[1])
        }
      },
    })

    // Sync hidden fields with initial selection
    const selected = this.flatpickr.selectedDates
    if (selected.length >= 1 && this.hasStartDateInputTarget) {
      this.startDateInputTarget.value = this.formatDate(selected[0])
    }
    if (selected.length >= 2 && this.hasEndDateInputTarget) {
      this.endDateInputTarget.value = this.formatDate(selected[1])
    }

    if (this.flatpickr.altInput) {
      this.flatpickr.altInput.inputMode = 'none'
      this.flatpickr.altInput.readOnly = true
      this.flatpickr.altInput.style.fontSize = '16px'
    }
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }

  formatDate(d) {
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
